/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PrepaidBookingStatusDTO = {
    MAPPED: 'MAPPED',
    BOOKED: 'BOOKED',
    BOOKING_ERROR: 'BOOKING_ERROR'
} as const;
export type PrepaidBookingStatusDTO = typeof PrepaidBookingStatusDTO[keyof typeof PrepaidBookingStatusDTO];

